import React, { useState, useEffect } from "react";
import { object, number } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";

import StoryHeader from "../story-header";
import PaywallCard from "../../molecules/paywall";
import { StoryCard } from "../story-elements";
import Tags from "../story-elements/tags";
import StorySideBar from "../story-sidebar";

import "./listcle.m.css";
import MoreNews from "../story-elements/more-news";
import { WithLazy } from "@quintype/components";
import LatestNews from "../story-elements/latest-news";
import useDevice from "../../helper/custom-hook/useDevice";

const ListcleStoryTemplate = ({ story, index }) => {
  const isMobile = useDevice();
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
  const isPremiumStory = story?.access === "subscription";

  const [premiumCards, setPremiumCards] = useState(isPremiumStory && !isAdfree ? null : story.cards);

  useEffect(() => {
    if (!isPremiumStory || isAdfree || typeof window === "undefined") {
      setPremiumCards(story.cards);
      return;
    }

    const getPremiumCards = () => {
      let cardsCount = 0;
      let elementsCount = 0;

      for (const card of story.cards) {
        cardsCount++;
        for (const element of card["story-elements"]) {
          elementsCount++;
          if (element.type === "text" || element.type === "image") {
            if (cardsCount >= 2 && elementsCount >= 3) break;
          }
        }
        if (cardsCount >= 2 && elementsCount >= 3) break;
      }
      return story.cards.slice(0, cardsCount);
    };

    setPremiumCards(getPremiumCards());
  }, [story.cards, isAdfree, isPremiumStory]);

  const cardsToRender = isPremiumStory && !isAdfree ? premiumCards : story.cards;

  return (
    <>
      <div styleName="story-wrapper">
        <div className="story-section">
          <div>
            <StoryHeader story={story} />
            <div id={`story-content-${story.id}`} className="story-cards">
              {(cardsToRender || []).map((card, index) => (
                <div key={index}>
                  <div styleName="decimal"> {index === 0 ? "Introduction" : index}</div>
                  <StoryCard card={card} story={story} key={index} />
                </div>
              ))}
            </div>
            {isPremiumStory && !isAdfree && <PaywallCard story={story} />}
            <Tags story={story} />
          </div>
        </div>

        {isMobile ? (
          <div>
            <WithLazy margin="300px">{() => <LatestNews story={story} />}</WithLazy>
          </div>
        ) : (
          <>
            <div className="side-story-section ">
              <StorySideBar index={index} story={story} />
            </div>

            {/* <div className="more-news-section ">
              <MoreNews story={story} />
            </div> */}
          </>
        )}
      </div>
    </>
  );
};

ListcleStoryTemplate.propTypes = {
  story: object,
  index: number
};

const ListcleStory = (props) => {
  return <ListcleStoryTemplate story={props.story} index={props.index} />;
};

ListcleStory.propTypes = {
  story: object,
  index: number
};

export default ListcleStory;
